import { styled } from '@/stitches.config';
import { Box, Label } from '../../atoms';

export const StyledContainer = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column'
});

export const StyledLabel = styled(Label, {
  color: '$darkBlue300',
  fontSize: '$lg',
  fontWeight: '$medium',
  textAlign: 'start',
  
  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
        color: '$darkGray600'
      },
    }
  },
});

export const StyledRadioGroup = styled('div', {
  marginTop: '$2',
  variants: {
    direction: {
      row: {
        display: 'flex',
        flexDirection: 'row',
      },
      rows: {
        display: 'block',
      },
      column: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  defaultVariants: {
    direction: 'row',
  },
});
